var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 58,
    viewBox: "0 0 44 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.499 34.2617H17.9326V33.7051C17.9326 32.7578 18.04 31.9912 18.2549 31.4053C18.4697 30.8096 18.7871 30.2676 19.207 29.7793C19.6367 29.291 20.5938 28.4316 22.0781 27.2012C22.8691 26.5566 23.2646 25.9658 23.2646 25.4287C23.2646 24.8916 23.1035 24.4766 22.7812 24.1836C22.4688 23.8809 21.9902 23.7295 21.3457 23.7295C20.6523 23.7295 20.0762 23.959 19.6172 24.418C19.168 24.877 18.8799 25.6777 18.7529 26.8203L13.0693 26.1172C13.2646 24.0273 14.0215 22.3477 15.3398 21.0781C16.668 19.7988 18.6992 19.1592 21.4336 19.1592C23.5625 19.1592 25.2812 19.6035 26.5898 20.4922C28.3672 21.6934 29.2559 23.2949 29.2559 25.2969C29.2559 26.127 29.0264 26.9277 28.5674 27.6992C28.1084 28.4707 27.1709 29.4131 25.7549 30.5264C24.7686 31.3076 24.1436 31.9375 23.8799 32.416C23.626 32.8848 23.499 33.5 23.499 34.2617ZM17.7422 35.7412H23.7041V41H17.7422V35.7412Z",
    fill: "#ACD4FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.1ac8fa98e635b4a33ad692d1601f467e.svg";
export { ForwardRef as ReactComponent };